import { AlignmentType, Document, Header as DocXHeader, WidthType } from "docx";
import formatDateTime from "../useFormatDateTime";
import { Body, breakLine, C, Header, line, table, text } from "./common";

const getVehicleForm = (item: any, employees: any) => {
  const jsonString = item.eContent;
  
  const dataArray = JSON.parse(jsonString);

  const creator = employees && employees.find((e: any) => e.eMail === item.createdByEmail.toLowerCase());


  (dataArray as any[]).reduce<{ types: any[]; trips: any[]; time: any[]; }>((result, item, index) => {
    const {
      fullYear: startFullYear, monthOfYear: startMonthOfYear, dayOfMonth: startDayOfMonth, minuteOfHour: startMinuteOfHour, hourOfDay: startHourOfDay,
    } = formatDateTime(item.StartDate);

    const {
      fullYear: endFullYear, monthOfYear: endMonthOfYear, dayOfMonth: endDayOfMonth, minuteOfHour: endMinuteOfHour, hourOfDay: endHourOfDay,
    } = formatDateTime(item.EndDate);

    result.types.push({ text: `\t- ${item.TypeVehicle},\tSố lượng: ${item.Amount} chiếc`, break: index > 0 ? 1 : 0 });
    result.trips.push({ text: `\t- ${item.TripItineraty}`, break: index > 0 ? 1 : 0 });
    result.time.push({ text: `\t- Từ ${startHourOfDay}h${startMinuteOfHour} ngày ${startDayOfMonth} tháng ${startMonthOfYear} năm ${startFullYear} - đến ${endHourOfDay}h${endMinuteOfHour} ngày ${endDayOfMonth} tháng ${endMonthOfYear} năm ${endFullYear}`, break: index > 0 ? 1 : 0 });
    return result;
  }, {
    types: [],
    trips: [],
    time: []
  })
  // Create the document
  const doc1 = new Document({
    sections: [
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, [
                  text(
                    [
                      {
                        text: "CÔNG TY DVMĐ SÂN BAY VIỆT NAM",
                        size: 22,
                      },
                      {
                        text: `ĐƠN VỊ: ${item.eUnit}`,
                        bold: true,
                        break: 1,
                        size: 24,
                      },
                    ],
                    {
                      alignment: AlignmentType.CENTER,
                    }
                  ),
                  line(800)
                ]),
                C.col(undefined, Header.rightParagraph)
              ),
            ],
          }),
        },
        children: [
          breakLine(1),

          Body.Date,

          breakLine(1),

          text([{ text: "GIẤY ĐỀ NGHỊ SỬ DỤNG XE CÔNG VỤ", bold: true }], {
            alignment: AlignmentType.CENTER,
          }),

          breakLine(1),

          text([{ text: "Kính gửi: VĂN PHÒNG CÔNG TY", bold: true }], {
            alignment: AlignmentType.CENTER,
          }),

          breakLine(3),

          text("\tCăn cứ kế hoạch làm việc của Đơn vị,"),

          breakLine(1),

          /**
           * ???: Chức vụ Empty
           */
          text(`\tHọ tên: ${creator?.Title || item.createdBy.user.displayName},\tChức vụ: ${creator?.eBizTitle || ''}`),

          breakLine(1),

          text(`\tĐơn vị: ${item.eUnit || ''}`),

          breakLine(1),

          text("\tĐề nghị sử dụng xe công vụ theo kế hoạch chi tiết sau:"),

          breakLine(1),

          // text("\t1/ Loại xe:"),

          // breakLine(1),

          // text(types, {alignment: AlignmentType.LEFT, spacing: {line: 360}}),

          // breakLine(1),

          // text("\t2/ Hành trình:"),

          // breakLine(1),

          // text(trips, {alignment: AlignmentType.LEFT, spacing: {line: 360}}),

          // breakLine(1),

          // text("\t3/ Thời gian:"),

          // breakLine(1),

          // text(time, {alignment: AlignmentType.LEFT, spacing: {line: 360}}),

          // breakLine(1),

          // text(`\t4/ Lý do sử dụng xe công vụ:`),

          // breakLine(1),

          // text(`\t- ${item.eDescription}`),

          // breakLine(1),

          // text("\t5/ Thông tin liên hệ:"),

          table<{
            TypeVehicle: string;
            Amount: string;
            TripItineraty: string;
            StartDate: string;
            EndDate: string;
          }>({
            columns: [
              {
                label: {
                  text: "Loại xe",
                  size: 22,
                },
                renderText: (item) =>
                  text({
                    text: item.TypeVehicle,
                    size: 22,
                  }, {alignment: AlignmentType.LEFT}),
              },
              {
                label: {
                  text: "Số lượng",
                  size: 22,
                },
                renderText: (item) =>
                  text({
                    text: item.Amount + "",
                    size: 22,
                  }, {alignment: AlignmentType.CENTER}),
              },
              {
                label: {
                  text: "Hành trình",
                  size: 22,
                },
                renderText: (item) =>
                  text({
                    text: item.TripItineraty,
                    size: 22,
                  }, {alignment: AlignmentType.LEFT}),
              },
              {
                label: {
                  text: "Thời gian",
                  size: 22,
                },
                renderText: (item) =>
                  text({
                    text: item.StartDate + " - " + item.EndDate,
                  }, {alignment: AlignmentType.LEFT}),
              },
            ],
            data: dataArray ?? [],
          }),

          breakLine(1),

          text(`\t- Lý do sử dụng xe công vụ: ${item.eDescription}`),

          breakLine(1),

          text(`\t- Đơn vị đề nghị: ông/bà ${creator?.Title || ''},\tđiện thoại: ${item.ePhoneNumber}`),

          breakLine(1),

          text("Trân trọng kính chào./."),

          breakLine(2),

          // Footer
          C.row(
            ...["VĂN PHÒNG CÔNG TY", "THỦ TRƯỞNG ĐƠN VỊ", "NGƯỜI ĐỀ NGHỊ"].map((v, i, o) => {
              return {
                width: {
                  size: 100 / o.length + "%",
                  type: WidthType.PERCENTAGE,
                },
                children: [
                  text([{ text: v, bold: true }], { alignment: AlignmentType.CENTER }),
                  text([{ break: 1 }]),
                ],
              };
            })
          ),
        ],
      },
    ],
  });
  return doc1;
};

export default getVehicleForm;
